/**
 * `<quick-order>` custom element (feature list v1.2, B2B).
 *
 * Collects every row with quantity > 0 and posts them together to
 * /cart/add.js as an items array. Quantities below a variant's minimum are
 * bumped up to it (AD-25). Confirmation lands in the live region and the
 * usual `thcabina:cart-updated` / `shopify:cart:lines-update` events fire —
 * the header count and the cart drawer react on their own.
 */
class QuickOrder extends AddToCartBase {
  connectedCallback() {
    this.button = this.querySelector('[data-quick-order-add]');
    this.statusEl = this.querySelector('[data-quick-order-status]');
    if (!this.button) return;
    this.button.addEventListener('click', () => this.add());
  }

  add() {
    const items = [];
    this.querySelectorAll('[data-quick-order-qty]').forEach((input) => {
      let quantity = parseInt(input.value, 10) || 0;
      if (quantity <= 0) return;
      const min = parseInt(input.dataset.min, 10) || 1;
      if (quantity < min) quantity = min;
      items.push({ id: Number(input.dataset.variantId), quantity });
    });

    if (items.length === 0) {
      this.setStatus(this.statusEl ? this.statusEl.dataset.emptyText : '', true);
      return;
    }

    this.addToCart({
      context: 'quick-order',
      lines: items.map((item) => ({ merchandiseId: item.id, quantity: item.quantity })),
      body: JSON.stringify({ items }),
      contentType: 'application/json',
      successMessage: this.statusEl ? this.statusEl.dataset.successText : '',
      button: this.button
    }).then((ok) => {
      if (!ok) return;
      this.querySelectorAll('[data-quick-order-qty]').forEach((input) => {
        input.value = '0';
      });
    });
  }

  setStatus(message, isError) {
    if (!this.statusEl) return;
    this.statusEl.textContent = message;
    this.statusEl.classList.toggle('quick-order__status--error', Boolean(isError));
  }
}

if (!customElements.get('quick-order')) {
  customElements.define('quick-order', QuickOrder);
}
